import { initializeStep5 } from '../config-step-5/config-step-5.js'; 
import gustibusConfigData from '../config-data.js';
// console.log(gustibusConfigData);

export function initializeStep4() {
    const fourthStepGustibus = document.querySelector('.fourth-step-gustibus');
    const fourthStepPrivate = document.querySelector('.fourth-step-private');
    const recipeElementsContainer = document.querySelector('.recipe-elements');
    recipeElementsContainer.innerHTML = '';

    const ingredientsContainerGustibus = document.querySelector('.fourth-step-gustibus .ingredients-elements');
    ingredientsContainerGustibus.innerHTML = '';

    const ingredientsContainerPrivate = document.querySelector('.fourth-step-private .ingredients-elements');
    ingredientsContainerPrivate.innerHTML = '';

    const recipeSelect = document.querySelector('.recipe-select');
    const recepies = getRecipes();
    let recepiesIDS = [];
    const recipesArray = [];
    const ingredientsIDS = [];
    const ingredientsData2 = {
        ingredients: []
    };

    function handleProductResult() {
        const selectedData = window.mergedData;
        var desktopResultsContainers = document.querySelectorAll('.desktop-product-result .result-product-wrapper');
        var mobileResultsContainers = document.querySelectorAll('.result-product-mobile');
        var mobileResultsButtonContainers = document.querySelectorAll('.result-btn-mobile');
        desktopResultsContainers.forEach((container) => {
            handleFormatIcon(container);
            handleProductName(container);
            handleLabel(container);
            handleUnit(container);
            handleFormat(container);
            handlePackage(container);

            if(selectedData.selectedBrand == 'gustibus') {
                handleSelectedRecipe();
            } else {
                const productSidebar = document.querySelectorAll('.result-product-wrapper');
                productSidebar.forEach((sidebarContianer) => {
                    const ingredientContainer = sidebarContianer.querySelector('.product-dsp .ingredients .ingredient');
                    ingredientContainer.innerHTML = '';
                });
            }

            handleSelectedIngredients();
        });

        mobileResultsContainers.forEach((container) => {
            handleFormatIcon(container);
            handleProductName(container);
            handleLabel(container);
            handleUnit(container);
            handleFormat(container);
            handlePackage(container);

            if(selectedData.selectedBrand == 'gustibus') {
                handleSelectedRecipe();
            }

            handleSelectedIngredients();
        });

        mobileResultsButtonContainers.forEach((container) => {
            handleMobileButtonsContainer(container);
        })

        
    }

    function handleMobileButtonsContainer(container) {
        const selectedData = window.mergedData;
        const productName = container.querySelector('.dsp-wrapper .title');
        let name = '';

        if(selectedData.selectedCategory) {
            name = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].name;

            document.querySelector('#selected_product').value = parseInt(selectedData.selectedCategory);
        }

        if(selectedData.selectedSubcategory) {
            const part1 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].name;
            name = part1;

            document.querySelector('#selected_category').value = parseInt(selectedData.selectedSubcategory);
        } 

        if(selectedData.selectedGroup) {
            const part1 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].name;
            const part2 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].groups[parseInt(selectedData.selectedGroup)].name;
            name = part1 + ' di ' + part2;

            document.querySelector('#selected_typology').value = parseInt(selectedData.selectedGroup);
            
        } 
        
        if(productName) {
            productName.innerHTML = name;
        }

    }

    function handleSelectedRecipe() {
        //TODO: display recipe to the sidebar
        // maybe unify html for desktop and mobile
        const activeRecipe = document.querySelector('.recipe-element.active .recipe-name');
        if(!activeRecipe) {
            return;
        }
        const selectedRecipeName = document.querySelector('.recipe-element.active .recipe-name').textContent;
        const productSidebar = document.querySelectorAll('.result-product-wrapper');
        productSidebar.forEach((sidebarContianer) => {
            const ingredientContainer = sidebarContianer.querySelector('.product-dsp .ingredients .ingredient');
            ingredientContainer.innerHTML = selectedRecipeName;
        });

        document.querySelector('#selected_recipe').value = document.querySelector('.recipe-element.active').getAttribute('data-recipe-id')

    }

    function handleSelectedIngredients() {
        const selectedData = window.mergedData;
        let ingredients = '';

        if(selectedData.selectedBrand == 'gustibus') {
            ingredients = document.querySelectorAll('.fourth-step-gustibus .ingredients-elements .ingredients-element.active');
        } else {
            ingredients = document.querySelectorAll('.fourth-step-private .ingredients-elements .ingredients-element.active');
            // reset form fields
            document.getElementById('selected_ingredients').value = '';
            document.getElementById('selected_recipe').value = '';

        }
        if(ingredients) {
            const selectedIngredients = [];
            const selectedIngredientsIDS = [];
            
            ingredients.forEach((ing) => {
                const ingName = ing.querySelector('.ingredients-name').textContent;
                if(!selectedIngredients.includes(ingName)) {
                    selectedIngredients.push(ingName);
                    selectedIngredientsIDS.push(ing.getAttribute('data-ingredient-id'));
                }
            });
            document.querySelector('#selected_ingredients').value = selectedIngredientsIDS.join(', ')
        } else {
            document.querySelector('#selected_ingredients').value = '';
        }
    }

    function handleFormat(container) {
        const selectedData = window.mergedData;
        const formatContainer = container.querySelector('.bottle-data');
        const formatNameContainer = formatContainer.querySelector('.name');
        const formatValueContainer = formatContainer.querySelector('.value');

        formatNameContainer.innerHTML = selectedData.selectedFormat.name;
        formatValueContainer.innerHTML = selectedData.selectedFormat.description;
        document.querySelector('#selected_format').value = selectedData.selectedFormat.id;

        var mobileResultsButtonContainers = document.querySelectorAll('.result-btn-mobile .mobile-btn-format-icon');
        mobileResultsButtonContainers.forEach((el) => {

            const pictureElement = document.createElement('picture');
            pictureElement.classList.add('img');

            const imgElement = document.createElement('img');
            imgElement.setAttribute('src', selectedData.selectedFormat.img);
            imgElement.setAttribute('data-src', selectedData.selectedFormat.img);
            imgElement.setAttribute('alt', 'Packaging icon');
            pictureElement.appendChild(imgElement);

            el.innerHTML = '';
            el.appendChild(pictureElement);
        })

    }
    
    function handlePackage(container) {
        const selectedData = window.mergedData;
        const packageContainer = container.querySelector('.cover-data .value');
        packageContainer.innerHTML = selectedData.selectedCover;

        document.getElementById('product_package').value = selectedData.selectedCover;

    }

    function handleUnit(container) {
        const selectedData = window.mergedData;
        const unitContainer = container.querySelector('.quantity-data .value');
        unitContainer.innerHTML = selectedData.selectedQuantity;

        document.getElementById('product_unit').value = selectedData.selectedQuantity;
    }

    function handleLabel(container) {
        const selectedData = window.mergedData;
        const labelContainer = container.querySelector('.label-data .value');
        const labelPreffix = labelContainer.getAttribute('data-name-preffix');
        labelContainer.innerHTML = labelPreffix + ' ' + capitalizeFirstLetter(selectedData.selectedBrand);

        document.getElementById('product_label').value = capitalizeFirstLetter(selectedData.selectedBrand);

    }

    function handleProductName(container) {
        const selectedData = window.mergedData;
        const productName = container.querySelector('.product-data .name');
        let name = '';

        if(selectedData.selectedCategory) {
            name = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].name;

            document.querySelector('#selected_product').value = parseInt(selectedData.selectedCategory);
        }

        if(selectedData.selectedSubcategory) {
            const part1 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].name;
            name = part1;

            document.querySelector('#selected_category').value = parseInt(selectedData.selectedSubcategory);
        } 

        if(selectedData.selectedGroup) {
            const part1 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].name;
            const part2 = gustibusConfigData.categories[parseInt(selectedData.selectedCategory)].subcategories[parseInt(selectedData.selectedSubcategory)].groups[parseInt(selectedData.selectedGroup)].name;
            name = part1 + ' di ' + part2;

            document.querySelector('#selected_typology').value = parseInt(selectedData.selectedGroup);
            
        } 
        
        productName.innerHTML = name;

    }

    function handleFormatIcon(container) {
        const selectedData = window.mergedData;
        const formatIconSource = container.querySelector('.product-icon picture source');
        const formatIconImg = container.querySelector('.product-icon picture img');
        formatIconSource.setAttribute('srcset', selectedData.selectedFormat.img);
        formatIconSource.setAttribute('data-srcset', selectedData.selectedFormat.img);
        formatIconImg.setAttribute('data-src', selectedData.selectedFormat.img);
        formatIconImg.setAttribute('src', selectedData.selectedFormat.img);
    }

    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function hideRiceteFromResults() {
        var productResultsContainers = document.querySelectorAll('.result-product-wrapper');

        productResultsContainers.forEach((container) => {
            var cont = container.querySelector('.ingredients');
            if(cont) {
                cont.style.display = 'none';
            }
        });
    }

    function showRiceteFromResults() {
        var productResultsContainers = document.querySelectorAll('.result-product-wrapper');

        productResultsContainers.forEach((container) => {
            var cont = container.querySelector('.ingredients');
            if(cont) {
                cont.style.display = '';
            }
        });
    }

    if(Object.keys(recepies).length > 0) {
        recepiesIDS = Object.keys(recepies);
        document.querySelector('#config-step-4').classList.remove('disabled');
        document.querySelector('[data-tab-target="#config-step-4"]').classList.remove('disabled');
        showRiceteFromResults();
        initializeStep5();
    } else {
        hideRiceteFromResults();
        initializeStep5();
        document.querySelector('#config-step-4').classList.add('disabled');
        document.querySelector('[data-tab-target="#config-step-4"]').classList.add('disabled');
        document.querySelector('[data-tab-target="#config-step-4"]').classList.remove('filled');
        document.querySelector('#config-step-4 .next-btn').classList.remove('disabled');
        document.querySelector('#config-step-4 .next-btn').click();
        document.querySelector('#config-step-4 .next-btn').classList.add('disabled');
        // handleTabNavigation('next');
        // const nextBtn = document.querySelector('.ingredients-recipes-wrapper .next-btn');
        // const prevBtn = document.querySelector('.ingredients-recipes-wrapper .prev-btn');
        // const formBtn = document.querySelector('.fifth-step-wrapper .prev-btn');
        // nextBtn.click();
        // if(!recepiesIDS.length) {
        //     formBtn.addEventListener('click', () => {
        //         prevBtn.click();
        //     });
        // }
    }

    recepiesIDS.forEach((recipeID) => {
        const rec = recepies[recipeID];

        if(recipeID != 0) {
            recipesArray.push(rec);
        }

        const ingIDS = Object.keys(rec.ingredients);
        ingIDS.forEach((ingID) => {
            if(!ingredientsIDS.includes(ingID)) {
                ingredientsIDS.push(ingID);
                ingredientsData2.ingredients.push(rec.ingredients[ingID]);
            }
        });

    });


    function getRecipes() {
        const selectedData = window.mergedData;
        let data = {};
        let formats = {};
        if(selectedData.selectedGroup || selectedData.selectedGroup != null) {
            formats = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].groups[selectedData.selectedGroup].formats[selectedData.selectedBrand][selectedData.selectedFormat['id']];
            // console.log(formats);
        } else if(selectedData.selectedSubcategory || selectedData.selectedSubcategory != null) {
            formats = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].formats[selectedData.selectedBrand][selectedData.selectedFormat['id']];
            // data = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].formats['gustibus'][selectedData.selectedFormat.id].recipes;
        } else if(selectedData.selectedCategory || selectedData.selectedCategory != null) {
            formats = gustibusConfigData.categories[selectedData.selectedCategory].formats[selectedData.selectedBrand][selectedData.selectedFormat['id']];
            // data = gustibusConfigData.categories[selectedData.selectedCategory].formats['gustibus'][selectedData.selectedFormat.id].recipes;
        } else {
            data = false;
        }

        if(formats.hasOwnProperty('recipes')) {
            for (const [key, value] of Object.entries(formats['recipes'])) {
                if(!data.hasOwnProperty(key)) {
                    data[key] = value;
                }
            }
        }
        // if(formats) {
        //     for (const [formatKey, formatValue] of Object.entries(formats)){
        //         if(formatValue.hasOwnProperty('recipes')) {
        //             for (const [key, value] of Object.entries(formatValue['recipes'])) {
        //                 if(!data.hasOwnProperty(key)) {
        //                     data[key] = value;
        //                 }
        //             }
        //         }
        //     }
        // }

        return data;
    }

    function createRecipeElement(recipe) {
        if(recipe.id === 0) {
            return;
        }
        const recipeElement = document.createElement('div');
        recipeElement.classList.add('recipe-element');
        recipeElement.style.order = recipe.order;
    
        const recipeNameSpan = document.createElement('span');
        recipeNameSpan.classList.add('recipe-name');
        recipeNameSpan.textContent = recipe.name;
        recipeElement.appendChild(recipeNameSpan);
    
        recipeElement.dataset.recipeId = recipe.id;
    
        recipeElement.addEventListener('click', function() {
            if(this.classList.contains('active')) {
                unselectRecipe();
                unselectIngredients();
                checkSelectionsStepFour();
            } else {
                document.querySelectorAll('.recipe-element').forEach(element => {
                    element.classList.remove('active');
                });
                recipeElement.classList.add('active');
                recipeSelect.value = recipeElement.getAttribute('data-recipe-id');
        
                highlightIngredients(recipe.ingredients);
                handleSelectedRecipe();
                handleSelectedIngredients();
                checkSelectionsStepFour();
            }
        });
    
        return recipeElement;
    }

    function unselectRecipe() {

        const activeRecipe = document.querySelector('.recipe-element.active');
        document.querySelector('select.recipe-select').value = '';
        if(!activeRecipe) {
            return;
        }
        activeRecipe.classList.remove('active');
        const productSidebar = document.querySelectorAll('.result-product-wrapper');
        productSidebar.forEach((sidebarContianer) => {
            const ingredientContainer = sidebarContianer.querySelector('.product-dsp .ingredients .ingredient');
            ingredientContainer.innerHTML = '';
        });

        document.querySelector('#selected_recipe').value = '';
        
    }

    function unselectIngredients() {
        document.querySelectorAll('.ingredients-element').forEach(element => {
            element.classList.remove('active');
        });

        handleSelectedIngredients();
    }

    function highlightIngredients(ingredientIds) {
        document.querySelectorAll('.ingredients-element').forEach(element => {
            element.classList.remove('active');
        });

        const ingIDS = Object.keys(ingredientIds);
        ingIDS.forEach(id => {
            const ingredientElement = document.querySelector(`.ingredients-element[data-ingredient-id="${id}"]`);
            if (ingredientElement) {
                ingredientElement.classList.add('active');
            }
        });
    }

    function handleRecipeSelectChange() {
        const selectedRecipeId = parseInt(recipeSelect.value);
        if(selectedRecipeId == 0) {
            unselectRecipe();
            unselectIngredients();
            checkSelectionsStepFour();
        }
        const selectedRecipe = recipesArray.find(recipe => recipe.id === selectedRecipeId);
        if (selectedRecipe) {
            const currActive = document.querySelector('.recipe-elements').querySelector('.recipe-element.active');
            if(currActive) {
                currActive.classList.remove('active');
            }
            const recipeElement = document.querySelector('.recipe-elements').querySelector(`.recipe-element[data-recipe-id="${selectedRecipe.id}"]`);
            if (recipeElement) {
                recipeElement.classList.add('active');
            }
            highlightIngredients(selectedRecipe.ingredients);
        }
        handleSelectedRecipe();
        handleSelectedIngredients();
        checkSelectionsStepFour();
    }

    recipeElementsContainer.innerHTML = '';
    recipeSelect.innerHTML = '<option value="0">Seleziona ricetta</option>'; 

    recipesArray.forEach(recipe => {
        const recipeElement = createRecipeElement(recipe);
        recipeElementsContainer.appendChild(recipeElement);

        const option = document.createElement('option');
        option.value = recipe.id;
        option.textContent = recipe.name;
        recipeSelect.appendChild(option);
    });

    recipeSelect.addEventListener('change', handleRecipeSelectChange);

    const selectedBrand = window.mergedData && window.mergedData.selectedBrand; 
    if (selectedBrand === 'private') {
        fourthStepGustibus.classList.remove('active');
        fourthStepPrivate.classList.add('active');
    } else {
        fourthStepGustibus.classList.add('active');
        fourthStepPrivate.classList.remove('active');
    }

    function createIngredientElement(ingredient, index) {
        const ingredientElement = document.createElement('div');
        ingredientElement.classList.add('ingredients-element', 'col-d-3');
        ingredientElement.setAttribute('data-ingredient-id', ingredient.id);
        ingredientElement.style.order = ingredient.order;

        const pictureWrapper = document.createElement('div');
        pictureWrapper.classList.add('icon-wrapper');

        const picture = document.createElement('picture');

        const img = document.createElement('img');
        img.setAttribute('src', ingredient.image);
        img.setAttribute('alt', '');

        picture.appendChild(img);
        pictureWrapper.appendChild(picture);

        const nameElement = document.createElement('span');
        nameElement.classList.add('ingredients-name');
        nameElement.textContent = ingredient.name;

        ingredientElement.appendChild(pictureWrapper);
        ingredientElement.appendChild(nameElement);

        return ingredientElement;
    }

    
    function createPrivateIngredientElement(ingredient) {
        const ingredientElement = document.createElement('div');
        ingredientElement.classList.add('ingredients-element', 'col-d-3');
        ingredientElement.setAttribute('data-ingredient-id', ingredient.id);
        ingredientElement.style.order = ingredient.order;

        const pictureWrapper = document.createElement('div');
        pictureWrapper.classList.add('icon-wrapper', 'col-3');

        const picture = document.createElement('picture');

        const img = document.createElement('img');
        img.setAttribute('src', ingredient.image);
        img.setAttribute('alt', '');

        picture.appendChild(img);
        pictureWrapper.appendChild(picture);

        const nameElement = document.createElement('span');
        nameElement.classList.add('ingredients-name', 'col-3');
        nameElement.textContent = ingredient.name;
        
        const closeElement = document.createElement('div');
        closeElement.classList.add('unselect-icon', 'col-3');
        const ingredientIcon = `
            <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                shape-rendering="geometricPrecision">
                <use xlink:href="/wp-content/themes/gustibusalimentari.it/assets/build/spritemap.svg#ico_close">
                </use>
            </svg>`;
        closeElement.innerHTML = ingredientIcon;

        ingredientElement.appendChild(pictureWrapper);
        ingredientElement.appendChild(nameElement);
        ingredientElement.appendChild(closeElement);
        ingredientElement.addEventListener('click', function() {
            this.classList.toggle('active');


            const productSidebar = document.querySelectorAll('.result-product-wrapper');
            const selectedIngredients = document.querySelectorAll('.fourth-step-private .ingredients-elements .ingredients-element.active');
            
            const selectedNames = [];
            selectedIngredients.forEach((el) => {
                const ingName = el.querySelector('.ingredients-name').textContent;
                if(!selectedNames.includes(ingName)) {
                    selectedNames.push(ingName);
                }
            });
            
            productSidebar.forEach((sidebarContianer) => {
                const ingredientContainer = sidebarContianer.querySelector('.product-dsp .ingredients .ingredient');
                ingredientContainer.innerHTML = selectedNames.join(', ');
            });

            checkSelectionsStepFour();
        });

        return ingredientElement;

    }

    ingredientsData2.ingredients.forEach((ingredient, index) => {
        const ingredientElement = createIngredientElement(ingredient, index);
        const privateElement = createPrivateIngredientElement(ingredient);
        ingredientsContainerPrivate.appendChild(privateElement);
        ingredientsContainerGustibus.appendChild(ingredientElement);

    });

    // const firstRecipeElement = recipeElementsContainer.querySelector('.recipe-element');
    // if (firstRecipeElement) {
    //     firstRecipeElement.classList.add('active');
    //     const firstRecipeIngredients = recipesArray.find( recipe => recipe.id === parseInt(firstRecipeElement.dataset.recipeId) )?.ingredients;
    //     if (firstRecipeIngredients) {
    //         highlightIngredients(firstRecipeIngredients);
    //     }
    // }

    handleProductResult();

    const nextBtn = document.querySelectorAll('#config-step-4 .ingredients-recipes-wrapper .next-btn');

    function checkSelectionsStepFour() {
        var isValid = false;
        const selectedData = window.mergedData;
        if(selectedData.selectedBrand === 'gustibus') {
            if(document.querySelectorAll('.recipe-element.active').length > 0 || parseInt(document.querySelector('select.recipe-select').value) > 0) {
                isValid = true;
            }
        } else {
            if(document.querySelectorAll('.ingredients-element.active').length > 0) {
                isValid = true;
            }
        }
        
        if(isValid) {
            nextBtn.forEach((el) => {
                el.classList.remove('disabled');
            });
        } else {
            nextBtn.forEach((el) => {
                el.classList.add('disabled');
            });
        }
    }

    checkSelectionsStepFour();

    nextBtn.forEach((el) => {
        el.addEventListener('click', function(e) {
            if(!this.classList.contains('disabled')) {
                handleSelectedIngredients();
            }
        });
    });

    function resetRecepiesIngredientsResults() {
        const ingredientsNames = document.querySelectorAll('.product-dsp .ingredients .ingredient');
        if(ingredientsNames) {
            ingredientsNames.forEach((el) => {
                el.innerHTML = '';
            })
        }
    }
    resetRecepiesIngredientsResults();

}
